import React, { useState, useEffect } from 'react';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import './Media.scss';

const Media = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [testimonials, setTestimonials] = useState([]);
  const [brands, setBrands] = useState([]);
  const [animationType, setAnimationType] = useState("in");

  const handleClick = (index, direction) => {
    setAnimationType((direction == "forwards" ? "in" : "out"))
    setCurrentIndex(index);
  };

  useEffect(() => {
    const query = '*[_type == "books"]';
    const brandsQuery = '*[_type == "brands"]';

    client.fetch(query).then((data) => {
      setTestimonials(data);
    });

    client.fetch(brandsQuery).then((data) => {
      setBrands(data);
    });
  }, []);

  return (
    <>
      <h2 style={{"marginBottom": "20px", "marginTop": "0px"}} className="head-text">Football Books</h2>
      <h2 style={{"marginBottom": "20px", "marginTop": "0px"}} className='subheader subheader-text'>
      I've read way too many football books. It's to the point now where I get eye rolls from certain unnamed 
      significant others whenever another football book shows up in the mail. These books have shaped the 
      way I think about the game. <br /> <br/>These are some of my favorites.
      </h2>

      {testimonials.length && (
        <>
        {testimonials.map((testimonial, i) => (
          <motion.div
            variants={{"in" : { x: [-100, 0], opacity: [0, 1]  }, "out" : { x: [100, 0], opacity: [0, 1]  }}}
            animate={(i == currentIndex ? animationType : "")}
            transition={{ duration: 1.0, type: 'tween' }}
            key={testimonial.name + "_" + i}
          >
            <div style={{"display" : (i == currentIndex ? "" : "none")}} className="app__testimonial-item app__flex">
              <div className="app__testimonial-content-left">
                <img className="app__testimonial-logo" src={urlFor(testimonial.logo)} alt={testimonial.name} />
                <div>
                  <h4 className="bold-text">{testimonial.name}</h4>
                  <h5 className="p-text">{testimonial.author}</h5>
                </div>
              </div>
              <div className="app__testimonial-content">
                <p className="p-text">{testimonial.desc}</p>
              </div>            
            </div>
          </motion.div>
        ))}

          <div className="app__testimonial-btns app__flex">
            <div className="app__flex" onClick={() => handleClick(currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1, "backwards")}>
              <HiChevronLeft />
            </div>

            <div className="app__flex" onClick={() => handleClick(currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1, "forwards")}>
              <HiChevronRight />
            </div>
          </div>
        </>
      )}

      <div className="app__testimonial-brands app__flex">
        {brands.map((brand) => (
          <motion.div
            whileInView={{ opacity: [0, 1] }}
            transition={{ duration: 0.5, type: 'tween' }}
            key={brand._id}
          >
            <img src={urlFor(brand.imgUrl)} alt={brand.name} />
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Media, 'app__testimonial'),
  'books',
  'app__primarybg',
);
